// 송장번호 일괄등록 섹션 URL (2026-10-29 KST 추가)
const orderTrackingSection = "/order-tracking";

export const orderTrackingPath = orderTrackingSection;
